// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_hg-3";
export var flatBottomCorners = "_hg-5";
export var productImage = "_hg-0";
export var quantityContainer = "_hg-2";
export var quantityHeader = "_hg-6";
export var tooltip = "_hg-1";
export var wrapAndEllipsesOverflow = "_hg-4";